import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { getSeats } from "@/lib/api";

// Live founder's-offer scarcity counter. `dark` = on forest surfaces.
export const SeatsLeft = ({ dark = false, className = "" }) => {
  const [seats, setSeats] = useState(null);

  useEffect(() => {
    getSeats().then(setSeats).catch(() => setSeats(null));
  }, []);

  if (!seats) return null;
  const pct = Math.min(100, Math.max(1.5, (seats.claimed / seats.total) * 100));

  return (
    <div className={className} data-testid="seats-left">
      <div className="flex items-center justify-between text-[12px]">
        <span className={`flex items-center gap-1.5 font-semibold ${dark ? "text-sa-copper" : "text-sa-copper"}`}>
          <Flame className="h-3.5 w-3.5" />
          Founder&apos;s offer seats
        </span>
        <span className={`font-medium ${dark ? "text-white/70" : "text-sa-muted"}`} data-testid="seats-left-count">
          {seats.left.toLocaleString("en-IN")} of {seats.total.toLocaleString("en-IN")} left
        </span>
      </div>
      <div className={`mt-1.5 h-1.5 overflow-hidden rounded-full ${dark ? "bg-white/10" : "bg-sa-beige"}`}>
        <div
          className="h-full rounded-full bg-sa-copper transition-[width] duration-700"
          style={{ width: `${pct}%` }}
          data-testid="seats-left-bar"
        />
      </div>
    </div>
  );
};

export default SeatsLeft;
